/**
 * Le pagine che lavorano su un obbligo alla volta lo dichiarano nell'URL con
 * `?nodo=`: Pubblicazioni come filtro, Documenti e cartelle come obbligo
 * scelto nell'albero. Il widget legge solo quelle: su ogni altra pagina il
 * parametro, se c'e', riguarda altro.
 */

import type { Nodo } from "../api/types";

const ROTTE_CON_NODO = ["/pubblicazioni", "/documenti"];

export function idNodoDallaRotta(pathname: string, parametri: URLSearchParams): string | null {
  if (!ROTTE_CON_NODO.some((rotta) => pathname === rotta || pathname.startsWith(`${rotta}/`))) return null;
  const id = parametri.get("nodo");
  return id ? id : null;
}

/**
 * Dove porta un collegamento `[titolo](nodo:id)` scritto dal modello: alla
 * pagina Documenti e cartelle con quell'obbligo scelto. Solo gli obblighi
 * foglia sono una destinazione, perche' solo quelli si scelgono in quella
 * pagina; una sezione, o un id che non sta nell'alberatura dell'ente, resta
 * testo. Resta testo anche il nodo su cui l'operatore sta gia': un link che
 * porta dove si e' gia' occupa spazio e non dice nulla.
 */
export function destinazioneCollegamento(
  idNodo: string,
  nodi: readonly Pick<Nodo, "id_nodo" | "livello">[],
  idNodoCorrente: string | null = null,
): string | null {
  if (idNodo === idNodoCorrente) return null;
  const nodo = nodi.find((n) => n.id_nodo === idNodo);
  if (!nodo || nodo.livello !== 3) return null;
  return `/documenti?nodo=${encodeURIComponent(idNodo)}`;
}
